module.exports = __webpack_public_path__ + "img/question.a36f478d.png";